// ABOUTME: Profile management functions backed by the Worker API.
// ABOUTME: Replaces Supabase profiles table queries with fetch calls.

import { api } from "@/lib/supabase/client";
import { withErrorHandling } from "@/lib/errors";

type Profile = {
  id: string;
  email: string;
  username: string | null;
  postcode: string | null;
  property_type: string | null;
  created_at: string;
};

type ProfileUpdate = {
  username?: string;
  postcode?: string;
  property_type?: string;
};

export type { Profile, ProfileUpdate };

export const getProfile = withErrorHandling(
  async (_userId: string): Promise<Profile | null> => {
    const { profile } = await api.get<{ profile: Profile }>('/profiles/me');
    return profile;
  },
  null,
  'Failed to load profile'
);

export async function updateProfile(_userId: string, profile: ProfileUpdate) {
  const { profile: updated } = await api.put<{ profile: Profile }>('/profiles/me', profile);
  return updated;
}

export async function createProfile(_userId: string, _email: string, profile: ProfileUpdate) {
  return updateProfile(_userId, profile);
}

export async function isUsernameAvailable(username: string): Promise<boolean> {
  if (!username || username.trim() === '') return false;
  const { available } = await api.get<{ available: boolean }>(`/profiles/username-check/${encodeURIComponent(username)}`);
  return available;
}

export async function getProfileByUsername(username: string): Promise<Profile | null> {
  if (!username || username.trim() === '') return null;
  try {
    const { profile } = await api.get<{ profile: Profile | null }>(`/profiles/by-username/${encodeURIComponent(username)}`);
    return profile;
  } catch {
    return null;
  }
}
